module.exports = __webpack_public_path__ + "static/phoneCoupon-89365d43c4c3a0304c4f9db5b3993a24.png";